import AboutHero from './components/AboutHero';
import MisionVision from './components/MisionVision';
import MomentosCarousel from './components/MomentosCarousel';

export default function AboutUs() {
  return (
    <div className="bg-white">
      <AboutHero />
      <MisionVision />
      <MomentosCarousel />
    </div>
  );
}
